import React from 'react';

import { Divider } from '@rbilabs/universal-components';
import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

const offerTag = require('assets/images/nav/offers-active.svg');
const crown = require('assets/images/nav/rewards-active.svg');

const burger = require('./burger.svg');

export const Perks = () => {
  const isCanada = region === Region.CA;

  const perks = [
    {
      icon: crown,
      title: t('loyaltyProfileEarnCrownsTitle'),
      body: t('loyaltyProfileEarnCrownsBody', { crownsAmount: isCanada ? 100 : 10 }),
    },
    {
      icon: burger,
      title: t('loyaltyProfileRedeemCrownsTitle'),
      body: t('loyaltyProfileRedeemCrownsBody'),
    },
    {
      icon: offerTag,
      title: t('loyaltyProfileUnlockOffersTitle'),
      body: t('loyaltyProfileUnlockOffersBody'),
    },
  ];

  return (
    <View style={styles.card}>
      {perks.map((perk, index) => (
        <React.Fragment key={index}>
          {index > 0 && <Divider />}
          <View key={index} style={styles.perk}>
            <View style={styles.iconContainer}>
              <Image source={perk.icon} style={styles.icon} tintColor="#FA0" contentFit="contain" />
            </View>
            <View style={styles.textContainer}>
              <Typography fontFamily="heading" style={styles.perkTitle}>
                {perk.title}
              </Typography>
              <Typography style={styles.perkBody}>{perk.body}</Typography>
            </View>
          </View>
        </React.Fragment>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    paddingHorizontal: spacing.$2,
    borderRadius: 12,
    backgroundColor: primitive.$white,
  },
  perk: {
    paddingVertical: spacing.$4,
    paddingHorizontal: spacing.$2,
    flexDirection: 'row',
    gap: spacing.$3,
  },
  icon: {
    width: 32,
    height: 32,
  },
  perkTitle: {
    fontSize: primitive.fontSizes.md,
  },
  perkBody: {
    fontSize: primitive.fontSizes.xs,
  },
  iconContainer: {
    width: 54,
    height: 54,
    borderRadius: 50,
    backgroundColor: '#FEC',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    gap: spacing.$1,
    flex: 1,
  },
});
